import manageCookies from './manage-cookies'

export default {
    intro: 'We use technically necessary cookies as well as cookies to collect statistical data. In this way, information on your terminal device regarding your use of the trend manager is accessed or corresponding information is stored on your terminal device. We use the data collected in this way to enable a technically smooth use of the tool as well as to evaluate your use of the tool and thus to further develop and optimize functionalities and contents in the trend manager.',
    optionIntro: 'Click on "Accept all" to give your consent or click on "Manage cookie settings" to change settings in detail as well as to obtain further information on the cookies we use and to deselect cookies at any time.',
    button: {
        acceptAll: 'Accept All',
        rejectAll: 'Reject All',
        manage: 'Manage Cookie Settings'
    },
    optOut: {
        matomoLabel: 'Deactivate use of Matomo'
    },
    manageCookies
}
